

import Vue from 'vue'
import VConsole from 'vconsole'
import App from './App'
import router from './router'
import pcServer from './api/pcServer.js'
import mobileServer from './api/mobileServer.js'
import 'weixin-js-sdk'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import SIdentifyPc from './components/pc/identify'
import SIdentify from './components/mobile/identify'
Vue.use(SIdentify)
Vue.use(SIdentifyPc)

Vue.use(ElementUI)

Vue.use(ToastPlugin)
Vue.component('swiper', Swiper)


const isDebug = false

if (isDebug) new VConsole()

Vue.config.productionTip = false
Vue.prototype.$axiosPc = pcServer
Vue.prototype.$axiosMobile = mobileServer

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js